import { render, staticRenderFns } from "./PaddingsIcon.vue?vue&type=template&id=7e76c0e7&"
import script from "./PaddingsIcon.vue?vue&type=script&lang=js&"
export * from "./PaddingsIcon.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports